import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Sidebar from './Menu';
import { includes } from 'lodash';
import { useLocation } from 'react-router-dom';
import { SidebarContext } from './SidebarContext';

export { SidebarContext };

const MainLayout = ({ children, showToggle }) => {
  const location = useLocation();
  const isMobileLayout = Boolean(showToggle);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const userRole = useMemo(
    () => JSON.parse(localStorage?.getItem('roles') || '[]'),
    [],
  );

  // routes where sidebar should NOT show
  const noSidebarRoutes = useMemo(
    () => [
      '/map',
      '/incidents',
      '/map-history',
      '/control-room-chat',
      '/view-control-room-chat',
    ],
    [],
  );

  const shouldShowSidebar =
    !includes(userRole, 'USER') &&
    !noSidebarRoutes.includes(location.pathname);

  const closeMobileSidebar = useCallback(() => {
    setMobileSidebarOpen(false);
  }, []);

  const toggleMobileSidebar = useCallback(() => {
    setMobileSidebarOpen((open) => !open);
  }, []);

  useEffect(() => {
    setMobileSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isMobileLayout) setMobileSidebarOpen(false);
  }, [isMobileLayout]);

  return (
    <div className='layout-container main-layout-wrapper'>
      <SidebarContext.Provider
        value={{
          showToggle,
          isMobileLayout,
          mobileSidebarOpen,
          toggleMobileSidebar,
          closeMobileSidebar,
        }}
      >
        {shouldShowSidebar && (
          <>
            {isMobileLayout && mobileSidebarOpen && (
              <div
                className='sidebar-backdrop'
                onClick={closeMobileSidebar}
                aria-hidden='true'
              />
            )}
            <Sidebar />
          </>
        )}
        <div className='content-layout-wrapper__right'>{children}</div>
      </SidebarContext.Provider>
    </div>
  );
};

export default MainLayout;
